(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirec4ac"];
var parcelRegister = parcelRequire.register;
parcelRegister("kVSpL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eac7ca20ff004292$export$2e2bcd8739ae039);

var $inQn1 = parcelRequire("inQn1");

var $giM8N = parcelRequire("giM8N");

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $5GgJy = parcelRequire("5GgJy");

var $5Mkil = parcelRequire("5Mkil");

var $fRUpF = parcelRequire("fRUpF");

var $gpAW6 = parcelRequire("gpAW6");

var $35OBH = parcelRequire("35OBH");

var $gGPXq = parcelRequire("gGPXq");

var $7gWUw = parcelRequire("7gWUw");

var $iDMhu = parcelRequire("iDMhu");

var $ahcAq = parcelRequire("ahcAq");

var $kzBS7 = parcelRequire("kzBS7");

var $bLJet = parcelRequire("bLJet");


var $lBuWd = parcelRequire("lBuWd");
const $eac7ca20ff004292$var$_Statistics = ({ fighter: fighter })=>{
    const statistics = [
        {
            name: "Height",
            value: (0, $iDMhu.GetFeetInches)(fighter.height)
        },
        {
            name: "Reach",
            value: fighter.reach ? `${fighter.reach}"` : null
        },
        {
            name: "Age",
            value: (0, $iDMhu.GetAge)(fighter)
        },
        {
            name: "Weight",
            value: fighter.weight ? fighter.weight : null
        },
        {
            name: "Stance",
            value: fighter.stance
        },
        {
            name: "Hometown",
            value: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, fighter.hometown, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $bLJet.default), {
                countryCode: fighter.country
            }))
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, statistics.map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "item",
            key: s.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "key"
        }, s.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: `value${(0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).isNil(s.value) ? " placeholder" : ""}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).isNil(s.value) ? "\u2013" : s.value))));
};
const $eac7ca20ff004292$var$Fighter = ()=>{
    const { otx_fighter_id: otx_fighter_id } = (0, $bTBLz.useParams)();
    const tournamentFights = (0, $ahcAq.default)({
        url: (0, $gGPXq.default).ApiTournamentFights,
        key: "otx_fights"
    }).result.read();
    const fighter = (0, $ahcAq.default)({
        url: `${(0, $gGPXq.default).ApiFighters}/${otx_fighter_id}`,
        key: "otx_fighter"
    })?.result.read();
    if (!fighter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $lBuWd.default), null);
    // Hydrate fights with fight details including fighters
    fighter.otx_fights = [];
    for (const fight of [
        ...fighter.otx_fights1,
        ...fighter.otx_fights2
    ]){
        const getOtxFight = (id)=>{
            return (0, $ahcAq.default)({
                url: `${(0, $gGPXq.default).ApiFights}/${id}`,
                key: "otx_fight"
            })?.result.read();
        };
        // Note: Keep an eye on this if we notice any bugs with fights not showing up correctly
        // There are possible issues of using useFetch this way -- if we run into issues, we should refactor this
        fighter.otx_fights.push(getOtxFight(fight.id));
    }
    const fights = (0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).orderBy(fighter.otx_fights?.filter((f)=>f.otx_fighter1 && f.otx_fighter2), (f)=>f.starts_at, "desc");
    const rankings = [
        {
            organization: "IBF",
            ranking: fighter.ranking_ibf
        },
        {
            organization: "WBA",
            ranking: fighter.ranking_wba
        },
        {
            organization: "WBC",
            ranking: fighter.ranking_wbc
        },
        {
            organization: "WBO",
            ranking: fighter.ranking_wbo
        }
    ];
    const organizationRankings = (0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).orderBy(rankings.filter((r)=>r.ranking > 0), [
        "ranking",
        "organization"
    ], [
        "asc",
        "asc"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5Mkil.default), {
        title: (0, $iDMhu.GetFullName)(fighter),
        className: "fighter-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "fighter-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5GgJy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "fighter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "hero"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "hero-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "hero-image-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "hero-image"
    }, fighter.image_path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gpAW6.default), {
        src: `${(0, $gGPXq.default).OvertimeImagesOtx}/${fighter.image_path}`,
        mobileWidth: 285
    }) : fighter.gender === (0, $iDMhu.Genders).Female ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gpAW6.default), {
        src: `${(0, $7gWUw.imgPlaceholdersFighterFemaleBluePng)}`,
        mobileWidth: 285
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gpAW6.default), {
        src: `${(0, $7gWUw.imgPlaceholdersFighterMaleBluePng)}`,
        mobileWidth: 285
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "hero-image-background"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgOtxBrandmarkBlackPng)
    }))), organizationRankings.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "organization-rankings"
    }, organizationRankings.map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            key: r.organization,
            className: "organization"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "organization-ranking"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("span", {
            className: "ranking"
        }, "#", r.ranking), " ", r.organization)))) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "name"
    }, fighter.nick_name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "nick-name"
    }, '"', fighter.nick_name, '"'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "full-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "first-name"
    }, fighter.first_name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "last-name"
    }, fighter.last_name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "weight-class",
        href: `${(0, $kzBS7.RoutePaths).Fighters}#${fighter.weight_class}`
    }, fighter.weight_class), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "social desktop-only"
    }, fighter.social_tiktok && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: fighter.social_tiktok
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faTiktok)
    })), fighter.social_instagram && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: fighter.social_instagram
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faInstagram)
    })), fighter.social_youtube && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: fighter.social_youtube
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faYoutube)
    })), fighter.social_twitter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: fighter.social_twitter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faXTwitter)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "record"
    }, organizationRankings.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "organization-rankings"
    }, organizationRankings.map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            key: r.organization,
            className: "organization"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("span", {
            className: "ranking"
        }, "#", r.ranking), " ", r.organization))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "record-cards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "record-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", {
        className: "value"
    }, fighter.wins ?? 0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "label"
    }, "Win")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "record-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", {
        className: "value"
    }, fighter.loses ?? 0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "label"
    }, "Loss")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "record-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", {
        className: "value"
    }, fighter.split_decisions ?? 0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "label"
    }, "Draw"))), (fighter.kos > 0 || fighter.tkos > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "knock-outs"
    }, fighter.kos > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "knock-out"
    }, "KOs: ", fighter.kos ?? 0), fighter.tkos > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "knock-out"
    }, "TKOs: ", fighter.tkos ?? 0)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "statistics-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5GgJy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "statistics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "personal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($eac7ca20ff004292$var$_Statistics, {
        fighter: fighter
    })), fighter.biography || fighter.social_tiktok || fighter.social_instagram || fighter.social_youtube || fighter.social_twitter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "biography"
    }, fighter.biography?.split("\n\n").map((b, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("p", {
            key: i
        }, b)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "social mobile-only"
    }, fighter.social_tiktok && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: fighter.social_tiktok
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faTiktok)
    })), fighter.social_instagram && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: fighter.social_instagram
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faInstagram)
    })), fighter.social_youtube && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: fighter.social_youtube
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faYoutube)
    })), fighter.social_twitter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: fighter.social_twitter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faXTwitter)
    })))) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5GgJy.default), null, fighter.titles?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $35OBH.default), {
        borderTop: false
    }, "Career Accolades"), fighter.current_champion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "champion-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "champion-badge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        src: (0, $7gWUw.imgIconChampionBadgePng),
        alt: "Champion Badge"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "champion-info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h3", {
        className: "champion-title"
    }, "Current Champion"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("p", {
        className: "champion-name"
    }, fighter.current_champion || "WBC Heavy Weight Title holder"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "accolades"
    }, fighter.titles?.slice(0, 5).map((t)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "item",
            key: t
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "key"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
            src: (0, $7gWUw.imgIconTrophySvg)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "value"
        }, t))))), fighter.otx_fights?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "otx-fights"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $35OBH.default), {
        borderTop: fighter.titles?.length > 0
    }, "OTX Fights"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("section", {
        className: "fight-cards"
    }, fights.map((fight)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $fRUpF.default), {
            fight: fight,
            key: fight.id,
            tournamentFights: tournamentFights,
            displayOtxFightTitle: true,
            displayFightCtaButtons: true
        }))))));
};
var // Note: There can only be one export per page component for hot loading to work
$eac7ca20ff004292$export$2e2bcd8739ae039 = $eac7ca20ff004292$var$Fighter;

});

})();
//# sourceMappingURL=Fighter.9d1ee6d2.js.map
